import React from "react"
import styles from "./card.module.css"
import { MdArrowCircleDown, MdArrowCircleUp } from "react-icons/md"
import InfoTooltip from "../../components/InfoTooltip"

const Card = ({
    name,
    value,
    variation,
    is_positive,
    type = "default",
    description,
    tooltip
}) => {
    return (
        <div className={`${styles.card} ${styles[type]}`}>
            <div className={styles.header}>
                <span className={styles.title}>{name}</span>
                {tooltip && (
                    <InfoTooltip
                        text={tooltip}
                        preferredPosition="top"
                    />
                )}
            </div>

            <div className={styles.body}>
                <span className={`${styles.value} ${styles[type + "Text"]}`}>
                    {value}
                </span>
                {variation && (
                    <div
                        className={`${styles.comparison} ${is_positive ? styles.successText : styles.dangerText
                            }`}
                    >
                        {is_positive ? <MdArrowCircleUp /> : <MdArrowCircleDown />}
                        <span>{variation}</span>
                    </div>
                )}
            </div>

            {(variation || description) && (
                <div className={styles.footer}>
                    {description
                        ? description
                        : is_positive
                            ? "Aumento em relação ao período anterior"
                            : "Redução em relação ao período anterior"}
                </div>
            )}
        </div>
    )
}

export default Card
